import React from 'react';
import { useLink } from '@react-aria/link';
import styled from 'styled-components';

import { sitekitTokens } from '../../../../../tokens/components/SiteKit/tokens';
import { buttonTokens } from '../../../../../tokens/components/Button/tokens';

const SiteKitLogoAnchorWrapper = styled.a`
  background: transparent;
  border: none;
  cursor: pointer;
  display: block;
  height: ${sitekitTokens.CoreLogoSizeHeight};
  line-height: 1;
  padding: 0;
  width: 100%;

  &:focus {
    box-shadow: ${buttonTokens.ShadowSecondaryKeyboardFocus};
  }
`;

const SiteKitLogoAnchor = (props: { children: React.ReactNode; 'aria-label': string }) => {
  const { children, ...otherProps } = props;

  // This is a false positive, evaluated by Rodrigo
  // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
  const ref = React.useRef() as React.MutableRefObject<HTMLAnchorElement | null>;
  const { linkProps } = useLink({ ...props, elementType: 'a' }, ref);

  return (
    <SiteKitLogoAnchorWrapper {...linkProps} {...otherProps}>
      {children}
    </SiteKitLogoAnchorWrapper>
  );
};

SiteKitLogoAnchor.displayName = 'SiteKit.LogoButton';

export { SiteKitLogoAnchor };
